import { useMemo } from "react";
import { useBuildingDetail } from "../../../context/BuildingDetailContext";
import { Grid } from "@mui/material";
import { useBuildingOpen } from "../../../../../../store/slices/BuildingTools";
import { BuildingDetailUnidContextProvider } from "../../../context/BuildingDetailUnidContext";
import BuildingUnitForm from "./building-units-form/BuildingUnitForm";
import { useUnitsContext } from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/UnitsContext";
import List from "rc-virtual-list";
interface IBuildingUnitListProps {}
const BuildingUnitList = (props: IBuildingUnitListProps) => {
  const { indexBuilding } = useBuildingDetail();
  const { buildingOpen } = useBuildingOpen();
  const { fields } = useUnitsContext();
  const showList = useMemo(() => {
    return buildingOpen === indexBuilding;
  }, [buildingOpen, indexBuilding]);

  if (!showList) return null;

  return (
    <Grid container item xs={12}>
      <List
        style={{
          width: "100%"
        }}
        data={fields}
        height={fields.length <= 5 ? fields.length * 40 : 200}
        itemHeight={40}
        itemKey="id"
      >
        {(item, index) => (
          <BuildingDetailUnidContextProvider
            key={item.uuid}
            indexUnit={index}
            uuid={item.uuid}
          >
            <BuildingUnitForm key={item.uuid} />
          </BuildingDetailUnidContextProvider>
        )}
      </List>
    </Grid>
  );
};

export default BuildingUnitList;
